<template>
    <div class="col-md-12">
        <div class="card">
            <div class="card-header pb-0">
                <h3>Simple Form Wizard</h3><span>Please Make sure fill all the filed before click on next button</span>
            </div>
            <div class="card-body">
              
                <form-wizard @on-complete="onComplete" shape="tab"
    back-button-text="Go back!"
    next-button-text="Go next!">
            <tab-content>
                <div class="col-xs-12">
                    <div class="col-md-12">
                        <div class="mb-3">
                            <label class="control-label">First Name</label>
                            <input class="form-control" type="text" placeholder="Johan" required>
                        </div>
                        <div class="mb-3">
                            <label class="control-label">Last Name</label>
                            <input class="form-control" type="text" placeholder="Deo" required>
                        </div>
                    </div>
                </div>
            </tab-content>
            <tab-content>
                <div class="col-xs-12 ">
                    <div class="col-md-12">
                        <div class="mb-3">
                            <label class="control-label">Email</label>
                            <input class="form-control" type="text" placeholder="name@example.com" required>
                        </div>
                        <div class="mb-3">
                            <label class="control-label">Password</label>
                            <input class="form-control" type="password" placeholder="Password" required>
                        </div>
                    </div>
                </div>
            </tab-content>
            <tab-content>
                <div class="col-xs-12 ">
                    <div class="col-md-12">
                        <div class="mb-3">
                            <label class="control-label">Birth date</label>
                            <input class="form-control" type="date" required>
                        </div>
                        <div class="mb-3">
                            <label class="control-label">Have Passport</label>
                            <input class="form-control" type="text" placeholder="yes/No" required>
                        </div>
                    </div>
                </div>
            </tab-content>
            <tab-content>
                <div class="col-xs-12 ">
                    <div class="col-md-12">
                        <div class="mb-3">
                            <label class="control-label">State</label>
                            <input class="form-control mt-1" type="text" placeholder="State" required>
                        </div>
                        <div class="mb-3">
                            <label class="control-label">City</label>
                            <input class="form-control mt-1" type="text" placeholder="City" required>
                        </div>
                    </div>
                </div>
            </tab-content>
        </form-wizard>
            </div>
        </div>
    </div>
</template>
<script>
import { FormWizard, TabContent } from "vue3-form-wizard";
import 'vue3-form-wizard/dist/style.css'
export default {
    name: "App",
    components: {
        FormWizard,
        TabContent
    },
    data() {
        return {
            currentTabIndex: 0,
        };
    },
    methods: {
        onChangeCurrentTab(index) {
            this.currentTabIndex = index;
        },
    },
};
</script>
